import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\u010Ce\u0161tina",
  code: "cs",
  messages: {
    alert: {
      close: "Zav\u0159\xEDt"
    },
    authForm: {
      hidePassword: "Skr\xFDt heslo",
      showPassword: "Zobrazit heslo",
      submit: "Pokra\u010Dovat"
    },
    banner: {
      close: "Zav\u0159\xEDt"
    },
    calendar: {
      nextMonth: "Dal\u0161\xED m\u011Bs\xEDc",
      nextYear: "Dal\u0161\xED rok",
      prevMonth: "P\u0159edchoz\xED m\u011Bs\xEDc",
      prevYear: "P\u0159edchoz\xED rok"
    },
    carousel: {
      dots: "Vyberte sn\xEDmek k zobrazen\xED",
      goto: "P\u0159ej\xEDt na {slide}",
      next: "Dal\u0161\xED",
      prev: "P\u0159edchoz\xED"
    },
    chatPrompt: {
      placeholder: "Zde napi\u0161te sv\u016Fj text..."
    },
    chatPromptSubmit: {
      label: "Odeslat"
    },
    colorMode: {
      dark: "Tmav\xFD",
      light: "Sv\u011Btl\xFD",
      switchToDark: "P\u0159epnout na tmav\xFD re\u017Eim",
      switchToLight: "P\u0159epnout na sv\u011Btl\xFD re\u017Eim",
      system: "Syst\xE9mov\xFD"
    },
    commandPalette: {
      back: "Zp\u011Bt",
      close: "Zav\u0159\xEDt",
      noData: "\u017D\xE1dn\xE1 data",
      noMatch: "\u017D\xE1dn\xE1 shoda",
      placeholder: "Zadejte p\u0159\xEDkaz nebo hledejte..."
    },
    contentSearch: {
      links: "Odkazy",
      theme: "T\xE9ma"
    },
    contentSearchButton: {
      label: "Hledat..."
    },
    contentToc: {
      title: "Na t\xE9to str\xE1nce"
    },
    dashboardSearch: {
      theme: "T\xE9ma"
    },
    dashboardSearchButton: {
      label: "Hledat..."
    },
    dashboardSidebarCollapse: {
      collapse: "Sbalit postrann\xED panel",
      expand: "Rozbalit postrann\xED panel"
    },
    dashboardSidebarToggle: {
      close: "Zav\u0159\xEDt postrann\xED panel",
      open: "Otev\u0159\xEDt postrann\xED panel"
    },
    error: {
      clear: "Zp\u011Bt na \xFAvod"
    },
    fileUpload: {
      removeFile: "Odebrat {filename}"
    },
    header: {
      close: "Zav\u0159\xEDt menu",
      open: "Otev\u0159\xEDt menu"
    },
    inputMenu: {
      create: 'Vytvo\u0159it "{label}"',
      noData: "\u017D\xE1dn\xE1 data",
      noMatch: "\u017D\xE1dn\xE1 shoda"
    },
    inputNumber: {
      decrement: "Sn\xED\u017Eit",
      increment: "Zv\xFD\u0161it"
    },
    modal: {
      close: "Zav\u0159\xEDt"
    },
    pricingTable: {
      caption: "Porovn\xE1n\xED cenov\xFDch pl\xE1n\u016F"
    },
    prose: {
      codeCollapse: {
        closeText: "Sbalit",
        name: "k\xF3d",
        openText: "Rozbalit"
      },
      collapsible: {
        closeText: "Skr\xFDt",
        name: "vlastnosti",
        openText: "Zobrazit"
      },
      pre: {
        copy: "Kop\xEDrovat k\xF3d do schr\xE1nky"
      }
    },
    selectMenu: {
      create: 'Vytvo\u0159it "{label}"',
      noData: "\u017D\xE1dn\xE1 data",
      noMatch: "\u017D\xE1dn\xE1 shoda",
      search: "Hledat..."
    },
    slideover: {
      close: "Zav\u0159\xEDt"
    },
    table: {
      noData: "\u017D\xE1dn\xE1 data"
    },
    toast: {
      close: "Zav\u0159\xEDt"
    }
  }
});
